import { createSelector } from 'reselect';

const teamManagementState = (store) => store.apps.teamManagement;
const routerMatch = (_store, ownProps) => ownProps.match;

const containerSelector = createSelector(
  [teamManagementState, routerMatch],
  (teamManagement, match) => ({
    activity: teamManagement.groupDetails.get('activity'),
    group: teamManagement.groupDetails.get('group'),
    groupId: match.params.groupId,
    loading: teamManagement.groupDetails.get('loading'),
    organizationSettings: teamManagement.organization.get('settings'),
    selectedTeams: teamManagement.groupDetails.get('selectedTeams'),
    teams: teamManagement.groupDetails.get('teams'),
  }),
);

const groupsEnabledSelector = createSelector(
  teamManagementState,
  ({ organization }) => {
    const groupsEnabled = organization.getIn(['settings', 'groups_enabled']);

    if ([true, false].includes(groupsEnabled)) {
      return { groupsEnabled, loading: false };
    }

    return { loading: true };
  },
);

export const teamsSelector = createSelector(
  teamManagementState,
  (filteredState) => ({ teams: filteredState.groupDetails.get('teams') }),
);

export default containerSelector;
export {
  containerSelector,
  groupsEnabledSelector,
  routerMatch,
  teamManagementState,
};
